import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModelCreds } from '../_models/modelCreds';
import { CustomerService } from '../_services/customer.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit {
  registerMode = false;
  securitycodeMode = false;
  forgotpasswordMode = false;
  users: any;
  model: ModelCreds = {username : '', password : ''};
  validationErrors: any[] = [];

  constructor(public customerService: CustomerService, private router: Router) { }

  ngOnInit(): void {
    const isTokenExpired = this.customerService.isTokenExpired();
    if (!isTokenExpired)
    {
      this.router.navigateByUrl('pricelist');
    }
  }

  registerToggle(){
    this.registerMode = true;
  }

  cancelRegisterMode(event: boolean)
  {
    this.registerMode = event;
  }

  securitycodeToggle(){
    this.securitycodeMode = true;
  }

  cancelSecuritycode(){
    this.securitycodeMode = false;
  }

  cancelSecuritycodeMode(event: boolean)
  {
    this.securitycodeMode = event;
  }

  forgotpasswordToggle(){
    this.forgotpasswordMode = true;
  }

  cancelForgotpassword(){
    this.forgotpasswordMode = false;
  }

  cancelForgotpasswordMode(event: boolean)
  {
    this.forgotpasswordMode = event;
  }

  templogin()
  {
    this.customerService.templogin(this.model).subscribe(response=>{
      
      this.securitycodeToggle();

    }, error => {

      console.log("error: " + error.error);
      this.validationErrors = error.error;
    });
    
  }

}
